import debounce from "lodash-es/debounce"
import addSpaceToNumber from "./format-number"
import { cylStateOneGreen, cylStateTwoGreen, cylStateThreeGreen } from "./cyl-green"
import { cylStateOneBlue, cylStateTwoBlue, cylStateThreeBlue, cylBlueAnimation } from "./cyl-blue"

const MIN_VAL = 100
const MAX_VAL = 10000000
const GROW_STEPS = 60
const valStepsArr = [100, 1000, 5000, 10000]
const $input = $("[data-profit=input]")
const $cylTotal = $("[data-profit=cyl-total]")
let valStep
let inputVal
let growStep

const getGrowStep = (number) => {
  for (let i = 0; i < GROW_STEPS; i++) {
    if (number >= valStepsArr[i] && number <= valStepsArr[i + 1]) {
      growStep = valStepsArr.indexOf(valStepsArr[i + 1])
      return growStep
    }
  }
}

const initCyl = () => {
  inputVal = $input.val()

  if (inputVal <= MIN_VAL || !inputVal) {
    $cylTotal.text(addSpaceToNumber(MIN_VAL))
    cylStateOneGreen(MIN_VAL)
    cylStateOneBlue(MIN_VAL)
  } else if (inputVal > MAX_VAL) {
    $cylTotal.text(addSpaceToNumber(MAX_VAL))
    cylStateTwoGreen(MAX_VAL)
    cylStateTwoBlue(MAX_VAL)
  } else {
    $cylTotal.text(addSpaceToNumber(inputVal))
    getGrowStep(inputVal)
    cylStateThreeGreen(inputVal, growStep)
    cylStateThreeBlue(inputVal, growStep)
  }
}

const growCyl = () => {
  $input.on("propertychange input", () => {
    inputVal = parseInt($input.val().replace(/\D/g, ""), 10) // parseInt - чтобы избежать появления лишних нулей в начале чисел на графиках

    if (inputVal <= MIN_VAL || !inputVal) {
      $cylTotal.text(addSpaceToNumber(MIN_VAL))
      cylStateOneGreen(MIN_VAL)
      cylStateOneBlue(MIN_VAL)
    } else if (inputVal > MAX_VAL) {
      $cylTotal.text(addSpaceToNumber(MAX_VAL))
      cylStateTwoGreen(MAX_VAL)
      cylStateTwoBlue(MAX_VAL)
    } else {
      $cylTotal.text(addSpaceToNumber(inputVal))
      getGrowStep(inputVal)
      cylStateThreeGreen(inputVal, growStep)
      cylStateThreeBlue(inputVal, growStep)
    }
  })

  $input.on("click keyup", debounce(cylBlueAnimation, 300))

  $input.on("propertychange input", () => {
    inputVal = $input.val().replace(/\D/g, "") // т.к. тайп инпута tel(чтобы добавлять пробелы между каждой третьей цифрой), то чтобы работать с его значением, нужно убирать пробелы

    if (inputVal > MAX_VAL) {
      $input.val(addSpaceToNumber("10000000"))
    } else if (inputVal.length > 1) {
      $input.val(addSpaceToNumber(inputVal.replace(/^0+/, ""))) // Можно ввести 0, но нельзя вводить что-то вроде 012345
    } else {
      $input.val(addSpaceToNumber(inputVal))
    }
  })

  $input.on("blur", () => {
    if (!inputVal || inputVal < MIN_VAL) {
      $input.val(MIN_VAL.toString())
      initCyl()
    } else {
      $input.val(addSpaceToNumber(inputVal))
    }
  })
}

const makeStepsArr = () => {
  for (let i = 0; i < 18; i++) {
    valStep = valStepsArr[valStepsArr.length - 1] + 5000
    valStepsArr.push(valStep)
  }

  for (let i = 0; i < 10; i++) {
    valStep = valStepsArr[valStepsArr.length - 1] + 10000
    valStepsArr.push(valStep)
  }

  for (let i = 0; i < 6; i++) {
    valStep = valStepsArr[valStepsArr.length - 1] + 50000
    valStepsArr.push(valStep)
  }

  for (let i = 0; i < 5; i++) {
    valStep = valStepsArr[valStepsArr.length - 1] + 100000
    valStepsArr.push(valStep)
  }

  for (let i = 0; i < 18; i++) {
    valStep = valStepsArr[valStepsArr.length - 1] + 500000
    valStepsArr.push(valStep)
  }
}

makeStepsArr()
initCyl()
growCyl()



// WEBPACK FOOTER //
// ./src/blocks/barrels/barrels.js